import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CTASection from './components/CTASection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import ComparisonTable from './components/ComparisonTable';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants/site';

const siteUrl = SITE_URL;

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Spreadsheet Hub',
  url: siteUrl,
  description: 'The ultimate resource for verified Superbuy Spreadsheet product finds, organized shopping guides, and curated category links.',
  logo: `${siteUrl}/favicon.ico`,
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Spreadsheet Hub',
  url: siteUrl,
  description: 'Discover organized Superbuy Spreadsheet collections with verified product links across 14 categories including shoes, hoodies, jackets, accessories and more.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <Navbar />
      <HeroSection />
      <CTASection />
      <AboutSection />
      <CategoryGrid />
      <ComparisonTable />
      <FeatureGrid />
      <TestimonialSection />
      <Footer />
    </main>
  );
}